// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"b7df6e0e","453":"ddae7e38"}[chunkId] + ".chunk.js";
};